<script>
    import { katexify } from "./custom_actions";
</script>

<span use:katexify>
    <slot />
</span>